import { Component, OnInit } from '@angular/core';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
@Component({
  selector: 'app-forms',
  templateUrl: './forms.component.html',
  styleUrls: ['./forms.component.scss']
})
export class FormsComponent implements OnInit {
  ckeConfig: any;
  mytime: Date = new Date();
  public Editor = ClassicEditor;
  constructor() { }

  ngOnInit(): void {
  }

}
